import React, { memo } from "react";
import { css } from "@emotion/core";
import WithStyles from "shared/components/WithStyles";
import { DWEB_MAX_WIDTH, FONTS, MEDIA_BREAKPOINTS, BREAKPOINTS } from "shared/styles/base";
import ResponsiveLoader from "shared/components/ResponsiveLoader";

import DonwloadApp from "./components/DownloadApp";
import NewsLetter from "./components/NewsLetter";
import ForQueries from "./components/ForQueries";

const subCss = css`
    background: #333;
    padding: 28px 0;

    .content {
        display: flex;
        max-width: ${DWEB_MAX_WIDTH}px;
        margin: 0 auto;
        color: #fff;
        font-family: ${FONTS.CERA};
        padding: 0 10px;

        ${MEDIA_BREAKPOINTS.TABLET} {
            flex-flow: row-reverse;
        }

        @media (max-width: ${BREAKPOINTS.TABLET}px) {
            flex-wrap: wrap;
        }
    }
`;

function Subscription() {
    return (
        <WithStyles cssProps={subCss}>
            <div className="content">
                <DonwloadApp />
                <NewsLetter />
                <ResponsiveLoader breakpoint={800} up>
                    <ForQueries />
                </ResponsiveLoader>
            </div>
        </WithStyles>
    );
}

export default memo(Subscription);
